/* eslint eqeqeq: 0 */
import React, { Component } from "react";
import { connect } from "react-redux";

import styled from "styled-components";
import RaisedButton from "material-ui/RaisedButton";

import {
  BODY_TEXT_COLOR,
  NEGATIVE_COLOR,
  THIRD_COLOR
} from "../../config/colors";
import { NoteIcon } from "../../icons";
import { myaccountUri } from "../../config/uri";

import * as modal from "../../reducers/modalReducer";
import { hidePage } from "../../reducers/pageReducer";
import * as addressReducer from "../../reducers/addressReducer";
import {
  HeaderDiv,
  HeaderTitleDiv,
  HeaderIconImg
} from "../../pages";
import {
  savePrimaryAddress,
  saveAddress,
  removeAddress
} from "../../actions/address";
import {checkIsCorrectDeliveryAddress, fetchAndUpdateDeliveryOptions} from '../../actions/api';
import {formatAptNum} from "../../helpers/addressHelper";
import { pushWithQueryParams } from "../../services/uri";

const locationIcon = process.env.PUBLIC_URL + "/assets/img/icons/location.svg";
const styles = {
  editIcon: { width: "35px", height: "35px" },
  closeIconWrap: {
    position: "absolute",
    left: "20px",
    top: "5px",
    cursor: "pointer"
  },
  closeIcon: { height: "50px", width: "50px", color: THIRD_COLOR },
  labelStyle: { fontWeight: 700 },
  addrErrorMessage: {fontSize: '12px', color: '#EA002D'}
};
class AddressesPage extends Component {
  state = {
    incorrectAddresses: []
  }

  secondaryColor = ["#", this.props.secondaryColor].join("");

  onCloseRequest = () => {
    this.props.hidePage();
    this.props.hideMenu();
  };
  onBackRequest = () => {
    this.props.hidePage();
  };
  handleEditClick = index => {
    this.props.openEditAddressModal({
      isDefault: index == this.props.currentAddressIdx,
      address: { ...this.props.addresses[index].address },
      onChange: this.handleChange.bind(null, index),
      onRemoveAddress: this.removeAddress.bind(null, index)
    });
  };

  removeAddress = index => {
    let addresses = [...this.props.addresses];
    // const currentAddressLast = addresses.length - 1 === this.props.currentAddressIdx;
    const addressId = this.props.addresses[index].address.id;

    addresses.splice(index, 1);
    // this.props.setDefaultAddress(this.props.currentAddressIdx - 1)
    this.props.setAddresses(addresses);
    if (
      this.props.address.currentAddressIdx > index &&
      this.props.address.isDelivery
    ) {
      this.props.setDelivery(this.props.address.currentAddressIdx - 1);
    }
    if (index === this.props.currentAddressIdx) {
      this.props.setPickup(-1);
    }
    this.props
      .removeAddress(addressId)
      .then(res => {})
      .catch(err => {
        console.log(err);
      });
  };

  handleChange = (index, address) => {
    let addresses = [...this.props.addresses];
    const _address = addresses[index].address;
    const editedAddress = { ..._address, ...address };
    addresses[index].address = editedAddress;
    this.props.setAddresses(addresses);
    this.props
      .saveAddress(editedAddress)
      .then(res => {})
      .catch(err => {
        console.log(err);
      });
    if (address.isdefault) {
      this.props.setDefaultAddress(index);
      const addressId = this.props.addresses[index].address.id;
      this.props
        .savePrimaryAddress({
          type: "DELIVERY",
          addressId: addressId
        })
        .then(res => {})
        .catch(err => {
          console.log(err);
        });
    }
  };

  handleBackBtn = () => {
    this.props.go(myaccountUri);
  };

  renderAddresses = addresses => {
    return addresses.map((addr, index) => (
      <AddressWrapper
        key={`${addr.address.street}${index}`}
      >
        <Address>
          <AddresLeftDiv onClick={this.handleEditClick.bind(null, index)}>
            <div>{addr.address.street}</div>
            <div>
              {addr.address.city}, {addr.address.state} {addr.address.zip}{formatAptNum(addr.address)}
            </div>
          </AddresLeftDiv>
          <AddressRightDiv>
            <NoteIcon style={styles.editIcon} color={NEGATIVE_COLOR} />
          </AddressRightDiv>
        </Address>
        <Hr />
      </AddressWrapper>
    ));
  };

  handleAddAddressClick = () => {
    this.props.openAddAddressForm();
  };

  isAddressBarOpened = () => {
    return this.props.isAddressBarOpened;
    // return this.props.isEcommerceEnabled && this.props.isAddressBarOpened;
  };

  render() {
    const isAddressBarOpened = this.isAddressBarOpened();
    return (
      <div style={{ position: "relative" }}>
        {/* <div onClick={this.handleBackBtn} style={styles.closeIconWrap}><ArrowLeft style={styles.closeIcon} /></div> */}
        <HeaderDiv>
          <HeaderIconImg src={locationIcon} />
          <HeaderTitleDiv>ADDRESSES</HeaderTitleDiv>
        </HeaderDiv>
        <AddressContainerDiv>
          {this.props.addresses.length > 0 &&
            this.renderAddresses(this.props.addresses)}
          {/*{ this.props.addresses.length == 0 && <AddLocationDiv color={this.secondaryColor} onClick={this.props.openShippingForm}>Add Location</AddLocationDiv> }*/}
        </AddressContainerDiv>
        <div style={{ textAlign: "center", paddingBottom: "40px" }}>
          <RaisedButton
            onClick={e => this.handleAddAddressClick(e)}
            label="Add Address"
            backgroundColor={`#` + this.props.secondaryColor}
            labelColor="#FFF"
            labelStyle={styles.labelStyle}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    // isEcommerceEnabled: state.config.isEcommerceEnabled,
    isAddressBarOpened: addressReducer.isAddressBarOpened(state),
    currentAddressIdx: addressReducer.getCurrentAddressIdx(state),
    addresses: addressReducer.getDeliveryAddresses(state),
    secondaryColor: state.config.secondaryColor,
    address: state.address
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateDeliveryOptions: () => dispatch(fetchAndUpdateDeliveryOptions()),
    checkIsCorrectDeliveryAddress: (placeId = '') => {
      return dispatch(checkIsCorrectDeliveryAddress(placeId));
    },
    saveAddress: address => saveAddress(address),
    savePrimaryAddress: address => savePrimaryAddress(address),
    removeAddress: address => removeAddress(address),
    go: uri => dispatch(pushWithQueryParams(uri)),
    setDefaultAddress: index => dispatch(addressReducer.setDelivery(index)),
    setAddresses: addresses =>
      dispatch(addressReducer.setDeliveryAddresses(addresses)),
    setPickup: bool => dispatch(addressReducer.setPickup(bool)),
    setDelivery: idx => dispatch(addressReducer.setDelivery(idx)),
    hidePage: () => dispatch(hidePage()),
    // hideMenu: () => dispatch(menu.menuOff()),
    openEditAddressModal: props =>
      dispatch(
        modal.openModal({
          modalType: "EDIT_ADDRESS_FORM",
          modalProps: props
        })
      ),
    openShippingForm: () =>
      dispatch(
        modal.openModal({
          modalType: "SHIPPING_FORM",
          modalProps: {}
        })
      ),
    openAddAddressForm: () =>
      dispatch(
        modal.openModal({
          modalType: "ADD_ADDRESS",
          modalProps: {}
        })
      ),
    clearTaxes: () => dispatch(startClearTaxes())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddressesPage);

const AddressContainerDiv = styled.div`
  font-family: "Roboto";
  display: flex;
  flex-direction: column;
  font-size: 16px;
  color: #515151;
  margin: 20px 40px;
  overflow: auto;
  height: 100%;
`;

const Address = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 16px;
  color: ${BODY_TEXT_COLOR};
  padding-bottom: 10px;
`;

const AddressWrapper = styled.div`
  padding-bottom: 10px;
  &:last-child {
    padding-bottom: 0;
  }
`;

const AddresLeftDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
const AddressRightDiv = styled.div`
  opacity: 0.3;
`;

const Hr = styled.hr`
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #f4f4f4;
  margin: 0;
  padding: 0;
`;



// WEBPACK FOOTER //
// ./src/components/AddressesPage/AddressesPage.jsx